__turbopack_context__.v({
  "btnBlock": "styles-module__88HBkW__btnBlock",
  "mainSearch": "styles-module__88HBkW__mainSearch",
  "showMap": "styles-module__88HBkW__showMap",
});
